// NGRX
import {Store, select} from '@ngrx/store';
// CRUD
import {BaseDataSource, QueryResultsModel} from '../../_base/crud';
// State
import {AppState} from '../../reducers';
// Selectirs
import {selectFireplacesChimneyBreastQueryResult, selectFireplacesChimneyBreastsPageLoading, selectFireplacesChimneyBreastsShowInitWaitingMessage} from '../_selectors/fireplaces-chimney-breast.selectors';

export class FireplacesChimneyBreastsDataSource extends BaseDataSource {
    trashed: number = 0;

    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectFireplacesChimneyBreastsPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectFireplacesChimneyBreastsShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectFireplacesChimneyBreastQueryResult)
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        });

    }
}
